export const ITEM_USAGE_PAGE_TITLE =
  "Ghi nhận sử dụng vật phẩm, các hoạt động của người chơi theo thời gian";

export const ITEM_USAGE_TABLE_COLUMNS = [
  { name: "Account", label: "Tài khoản" },
  { name: "CharacterId", label: "ID nhân vật" },
  { name: "Server", label: "Máy chủ" },
  { name: "Item", label: "Vật phẩm" },
  { name: "Price", label: "Giá" },
  { name: "CreatedDate", label: "Ngày tạo" },
];

export const ITEM_USAGE_FAKE_DATA = [
  {
    id: 1,
    Account: "accno01",
    CharacterId: "user1",
    Server: 1,
    Item: "Gói 1",
    Price: 10000,
    CreatedDate: "2025-10-21T10:40:39+07:00",
  },
  {
    id: 2,
    Account: "accno02",
    CharacterId: "user2",
    Server: 1,
    Item: "Gói 2",
    Price: 25000,
    CreatedDate: "2025-10-21T11:15:22+07:00",
  },
  {
    id: 3,
    Account: "accno03",
    CharacterId: "kiemvan88",
    Server: 2,
    Item: "Gói KNB",
    Price: 50000,
    CreatedDate: "2025-10-22T08:05:10+07:00",
  },
  {
    id: 4,
    Account: "player_alpha",
    CharacterId: "thanhphong",
    Server: 1,
    Item: "Gói 1",
    Price: 10000,
    CreatedDate: "2025-10-22T14:30:45+07:00",
  },
  {
    id: 5,
    Account: "accno05",
    CharacterId: "tuyetnhi",
    Server: 3,
    Item: "Gói VIP",
    Price: 100000,
    CreatedDate: "2025-10-23T09:12:00+07:00",
  },
  {
    id: 6,
    Account: "accno01",
    CharacterId: "user1",
    Server: 1,
    Item: "Gói 3",
    Price: 35000,
    CreatedDate: "2025-10-23T16:48:33+07:00",
  },
  {
    id: 7,
    Account: "hoalong99",
    CharacterId: "hoalong",
    Server: 2,
    Item: "Gói 2",
    Price: 25000,
    CreatedDate: "2025-10-24T10:20:18+07:00",
  },
  {
    id: 8,
    Account: "accno08",
    CharacterId: "bangtam",
    Server: 3,
    Item: "Gói KNB",
    Price: 50000,
    CreatedDate: "2025-10-24T19:55:07+07:00",
  },
];
